/**
 * In-memory holder for the derived signing identity.
 *
 * The Signer is a non-serializable class instance, so it lives here in a module
 * singleton rather than in the Redux store (which holds only the serializable
 * `{ unlocked, aid }` snapshot). Nothing here is persisted: a page reload drops
 * the identity and the user must re-enter their passcode. See the
 * `Browser Side Direct Signing` decision (this.i wqz7k3mnbp).
 */

import type {DerivedIdentity} from './httpsig';

let currentIdentity: DerivedIdentity | null = null;

export function setIdentity(identity: DerivedIdentity): void {
  currentIdentity = identity;
}

export function clearIdentity(): void {
  currentIdentity = null;
}

/** The active signing identity, or null when locked. */
export function getIdentity(): DerivedIdentity | null {
  return currentIdentity;
}
